import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('contact-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider
      .state('contact-view', {
        parent: 'arw',
        url: '/contact-us?tabId&inquiryReason',
        template: `<contact-us />`,
        redirectTo: 'contact',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Contact Us')));
            },
          ],
        },
      })
      .state('contact-manage', {
        parent: 'arw',
        url: '/manage-contact',
        template: `<manage-contact />`,
        redirectTo: 'home-view',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Lottery Contacts')));
            },
          ],
        },
      })
      .state('cms-inquiryReasonManagement', {
        parent: 'arw',
        url: '/inquiry-reason-management',
        template: `<inquiry-contacts-list />`,
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Inquiry Contacts')));
            },
          ],
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/contact/contact-routing-module.js